import { useForm } from '@refinedev/antd';
import { Create } from '@refinedev/antd';
import { Form, Input, InputNumber, Switch, Card, Row, Col } from 'antd';
import { LabelWithHelp, SectionTitle } from '../../components/ui/HelpTooltip';
import { t } from '../../i18n';

export const FaqCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/faqs',
    redirect: 'list',
  });

  return (
    <Create saveButtonProps={saveButtonProps} title={t('faq.newFaq')}>
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={8}>
            <Card
              title={
                <SectionTitle
                  title={t('faq.questionUz')}
                  help="FAQ ning o'zbek tilidagi versiyasi. Foydalanuvchilarga o'zbek tilida ko'rinadi."
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('faq.question')}
                    help="Foydalanuvchilar ko'p so'raydigan savol"
                  />
                }
                name="questionUz"
                rules={[{ required: true, message: 'Savolni kiriting' }]}
              >
                <Input.TextArea rows={2} placeholder="Qanday ro'yxatdan o'tish mumkin?" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('faq.answer')}
                    help="Savolga batafsil javob"
                  />
                }
                name="answerUz"
                rules={[{ required: true, message: 'Javobni kiriting' }]}
              >
                <Input.TextArea rows={4} placeholder="Telefon raqamingizni kiriting va SMS kodni tasdiqlang..." />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card
              title={
                <SectionTitle
                  title={t('faq.questionRu')}
                  help="FAQ ning rus tilidagi versiyasi. Foydalanuvchilarga rus tilida ko'rinadi."
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('faq.question')}
                    help="Savolning ruscha tarjimasi"
                  />
                }
                name="questionRu"
                rules={[{ required: true, message: 'Savolni kiriting' }]}
              >
                <Input.TextArea rows={2} placeholder="Как зарегистрироваться?" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('faq.answer')}
                    help="Javobning ruscha tarjimasi"
                  />
                }
                name="answerRu"
                rules={[{ required: true, message: 'Javobni kiriting' }]}
              >
                <Input.TextArea rows={4} placeholder="Введите номер телефона и подтвердите SMS код..." />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card
              title={
                <SectionTitle
                  title={t('faq.questionEn')}
                  help="FAQ ning ingliz tilidagi versiyasi. Foydalanuvchilarga ingliz tilida ko'rinadi."
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('faq.question')}
                    help="Savolning inglizcha tarjimasi"
                  />
                }
                name="questionEn"
                rules={[{ required: true, message: 'Savolni kiriting' }]}
              >
                <Input.TextArea rows={2} placeholder="How to register?" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('faq.answer')}
                    help="Javobning inglizcha tarjimasi"
                  />
                }
                name="answerEn"
                rules={[{ required: true, message: 'Javobni kiriting' }]}
              >
                <Input.TextArea rows={4} placeholder="Enter your phone number and confirm SMS code..." />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24}>
            <Card
              title={
                <SectionTitle
                  title={t('settings.title')}
                  help="FAQ ning kategoriyasi va tartib raqami"
                />
              }
            >
              <Row gutter={16}>
                <Col xs={24} md={8}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('faq.category')}
                        help="FAQ qaysi kategoriyaga tegishli. Masalan: Ro'yxatdan o'tish, To'lov, Sayohat"
                      />
                    }
                    name="category"
                  >
                    <Input placeholder="Ro'yxatdan o'tish" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('faq.sortOrder')}
                        help="FAQ qaysi tartibda ko'rinadi. Kichik raqamlar yuqorida ko'rinadi."
                      />
                    }
                    name="sortOrder"
                    initialValue={0}
                  >
                    <InputNumber min={0} placeholder="0" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('common.active')}
                        help="FAQ foydalanuvchilarga ko'rinadimi yoki yo'qmi"
                      />
                    }
                    name="isActive"
                    valuePropName="checked"
                    initialValue={true}
                  >
                    <Switch checkedChildren="Ha" unCheckedChildren="Yo'q" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
